import {
  SEARCH_SUCCESS,
  SEARCH_ERROR,
  RESULT_MORE,
  FOCUS_FIRST_NEW_ITEM_DONE,
} from "actions/const";
import { APP_INITIALIZE, QUERY_CHANGE, FILTER_CHANGE } from "actions/const";
import config from "config";
import * as queryUtils from "utils/query";
import * as filterUtils from "utils/filter";

function reducer(state = config.state.result, action) {
  switch (action.type) {
    case APP_INITIALIZE:
      const urlFilters = queryUtils.toFiltersLiteral(action.urlSearch);
      const filterKeys = Object.keys(urlFilters);
      const hasOnlyQuery =
        urlFilters[filterUtils.getQueryFilterName()] && filterKeys.length === 1;

      return filterKeys.length
        ? {
            ...state,
            changedFilterType: hasOnlyQuery ? "query" : "filter",
          }
        : state;

    case QUERY_CHANGE:
      return { ...state, changedFilterType: "query", offset: 0 };

    case FILTER_CHANGE:
      return { ...state, changedFilterType: "filter", offset: 0 };

    case RESULT_MORE:
      return {
        ...state,
        offset: state.offset + action.count,
        loadingMore: true,
        focusFirstNewItem: true,
      };

    case FOCUS_FIRST_NEW_ITEM_DONE:
      return {
        ...state,
        focusFirstNewItem: false,
      };

    case SEARCH_SUCCESS:
      let records = [];

      if (action.updateType === "replace") {
        records = action.result.records;
      }
      if (action.updateType === "append") {
        records = [...state.records, ...action.result.records];
      }
      const redirect = action.result.redirect
        ? { redirect: action.result.redirect }
        : {};
      return {
        ...state,
        totalCount: action.result.count,
        type: action.result.type,
        records,
        loadingMore: false,
        ...redirect,
      };

    case SEARCH_ERROR:
      return {
        ...state,
        totalCount: 0,
        records: [],
        loadingMore: false,
        focusFirstNewItem: false,
      };

    default:
      return state;
  }
}
export default reducer;
